namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem2ExemptRow {
        Id?: number;
        PmId?: string;
        PmDesc?: string;
        PmType?: number;
        PmGroupId?: string;
        PmExtCode?: string;
        PmStepNo?: number;
        PmOrder?: number;
        LineItemNo?: number;
        ItemType?: number;
        ListFg?: number;
        PluCode?: string;
        StyleCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        SupplCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
    }

    export namespace PsAdvPromoItem2ExemptRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.PsAdvPromoItem2Exempt';
        export const lookupKey = 'AdvPromo.PsAdvPromoItem2Exempt';

        export function getLookup(): Q.Lookup<PsAdvPromoItem2ExemptRow> {
            return Q.getLookup<PsAdvPromoItem2ExemptRow>('AdvPromo.PsAdvPromoItem2Exempt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PmId = "PmId",
            PmDesc = "PmDesc",
            PmType = "PmType",
            PmGroupId = "PmGroupId",
            PmExtCode = "PmExtCode",
            PmStepNo = "PmStepNo",
            PmOrder = "PmOrder",
            LineItemNo = "LineItemNo",
            ItemType = "ItemType",
            ListFg = "ListFg",
            PluCode = "PluCode",
            StyleCode = "StyleCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            SupplCode = "SupplCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate"
        }
    }
}
